import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postRestrictRuleSlice = createApi(`PostRestrictRuleSlice`,"POST");

const PostRestrictRuleSlice = createSlice({
  name: 'PostRestrictRuleSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postRestrictRuleSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postRestrictRuleSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postRestrictRuleSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostRestrictRuleSlice.reducer;